import * as yup from 'yup'

export const validationSchema = (t) =>
  yup.object().shape({
    name: yup.string().required(t('rewards.shop.form.error.shopName')),
    username: yup.string().required(t('rewards.shop.form.error.userID')),
    password: yup.string().required(t('rewards.shop.form.error.password')),
  })

export const validationSchemaEditNameShop = (t) =>
  yup.object().shape({
    name: yup.string().required(t('rewards.shop.form.error.shopName')),
  })

export const validationSchemaEditPassword = (t) =>
  yup.object().shape({
    password: yup.string().required(t('rewards.shop.form.error.password')),
  })
// export
// export default validationSchema
